import React, { useEffect } from 'react';
import { BgRow, Container } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import classes from './NgzChallengeLeaderboard.module.scss';
import { ChallengeBackgroundImg } from '../../components/ChallengeBackgroundImg/ChallengeBackgroundImg';
import { angularizeWithProviders } from '../../../shared/providers';
import { SwymoHeader } from '../../../shared/components/header-components/SwymoHeader/SwymoHeader';
import { ChallengeTitleBlock } from '../../components/ChallengeTitleBlock/ChallengeTitleBlock';
import { ScoringRuleRow } from './components/ScoringRuleRow/ScoringRuleRow';
import { leaderboardStore } from '../../stores/leaderboardStore';
import { getRouteParam, goTo } from '../../../shared/utils/angularUtils';
import { FiltersRow } from './components/FiltersRow/FiltersRow';
import { CHALLENGE_STATUS } from '../../constants/challengeStatus';
import { getIsRegistrationPeriod } from '../../utils/getIsRegistrationPeriod/getIsRegistrationPeriod';
import { ChallengeLeaderboard } from '../../containers/ChallengeLeaderboard/ChallengeLeaderboard';

const NgzChallengeLeaderboard = observer(() => {
  const { challengeInfo, getChallengeInfo, getLeaderboardList, setDefaultValues } =
    leaderboardStore;

  const challengeId = getRouteParam('challengeId');

  const getData = async () => {
    await getChallengeInfo(challengeId);
    await getLeaderboardList();
  };

  useEffect(() => {
    getData();

    return () => {
      setDefaultValues();
    };
  }, [challengeId]);

  if (!challengeInfo) {
    return null;
  }

  const isRegistrationPeriod =
    !!challengeInfo.importantDates &&
    getIsRegistrationPeriod(
      challengeInfo.importantDates.registrationStartDate,
      challengeInfo.importantDates.registrationEndDate,
    );

  const handleOpenChallengeClick = () => {
    if (challengeInfo.status === CHALLENGE_STATUS.DRAFT) {
      goTo(`/challenge-preview/${challengeId}`);
    } else {
      goTo(`/challenge-landing/${challengeId}`);
    }
  };

  return (
    <>
      <SwymoHeader inAngularContainer />
      <Container maxWidth="lg" className={classes.container}>
        <BgRow background={<ChallengeBackgroundImg className={classes.background} />}>
          <ChallengeTitleBlock
            challengeId={challengeId}
            openButtonTitle="Open Challenge"
            title={
              <>
                {challengeInfo.challengeName}{' '}
                <span className={classes.leaderboardTitle}>LEADERBOARD</span>
              </>
            }
            isRegistrationPeriod={isRegistrationPeriod}
            challengeStatus={challengeInfo.status}
            description={challengeInfo.description}
            onOpenButtonClick={handleOpenChallengeClick}
          />
          <FiltersRow />
          <ScoringRuleRow />
          <ChallengeLeaderboard />
        </BgRow>
      </Container>
    </>
  );
});

angularizeWithProviders(NgzChallengeLeaderboard, 'ngzChallengeLeaderboard', {});
